import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output, OnDestroy } from '@angular/core';
import {
  TablaMaestra,
  BaseControl,
  ColumnaMaestra,
  Forma,
  Control,
  SubForma,
  OptionsColumns,
  InformacionTablaMaestra,
  FiltrosSelectores,
  OpcionesListaChequeo,
  ColumnsTableModalSelect
} from '@app/shared';
import { CheckListFormsService } from './shared/check-list.forms.service';
import { CheckListDataService } from './shared/check-list.data.service';
import { find } from 'lodash';
import { CheckListOptionsComponent } from './check-list-options/check-list-options.component';
import { Subject } from 'rxjs';
import { async } from '@angular/core/testing';

@Component({
  selector: 'iw-check-list',
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.scss'],
  providers: [CheckListFormsService, CheckListDataService]
})
export class CheckListComponent implements OnInit, OnDestroy {

  // Id del formulario
  @Input() idForm = 0;
  // Orden del formulario dentro de la forma
  @Input() order: number;
  // Define si se atualiza el control o se crea
  @Input() update = false;
  // Identificador de el formulario
  @Input() formPrincipal: Forma;
  // Formulario
  @Input() form: SubForma;
  // Forma seleccionado
  formSelect = '';
  // Formulario seleccionado
  formularioSelect = '';
  // Contiene la columna de la maestra seleccionada
  columnMasterSelect = '';
  // Tipo de fuente de datos
  typeSourceSelect = 'TablaMaestra';
  // Contiene el id de la maestra dependencia seleccionada
  idMasterSelected = -1;
  // Lista de tablas maestraas
  masterTables: Array<TablaMaestra> = [];
  // Contiene temoralmente los registros especificos seleccionados
  tmpSpecificRecord: Array<number> = [];
  // Contiene toodas las formas inplicadas en la forma actual e incluyendo esta
  allForms: Array<{key: string, value: string}> = [];
  // Formularios de la forma seleccionada
  formularios: Array<{key: string, value: string}> = [];
  // Campos del formulario seleccionada
  fields: Array<OptionsColumns> = [];
  columnsMaster: Array<OptionsColumns> = [];
  columnsMasterFilters: Array<OptionsColumns> = [];
  // Contiene los controles de el formulario de lista de chequeo
  controls: BaseControl<any>[] = [];
  // Contiene temporalmente los filtros de la lista de chequeo selecionados
  tmpFormulariosFilters: Array<FiltrosSelectores> = [];
  // Contiene la maestra seleccionada
  master: InformacionTablaMaestra;
  // Contiene las opciones de la lista de chequeo
  checkLisdtOptions: OpcionesListaChequeo[] = [];
  // Contiene las diferentes opciones de los selects del formulario
  options = {};
  // Contiene los templetes de las forma
  templatesNgSelect = {};
  // Contiene los formularios anteriormente cargados
  acumulateForm: any = {};
  // Tipo de fuente de datos para seleccion multiple
  typeMultiSourceSelect = 'TablaForma';
  // Forma seleccionado
  formMultiSelect = '';
  // Formulario seleccionado
  formularioMultiSelect = '';
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia del templete de los selects para la carga de fuente (formulario o maestra)
  @ViewChild('templateNgSelect') private templateNgSelect: TemplateRef<any>;
  // Referencia del templete del select de las columnas
  @ViewChild('ngSelectColums') private ngSelectColums: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select para las columnas de formularios o maestras
  @ViewChild('ngSelect') private ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de opciones de lista de chequeo
  @ViewChild('optionsCheckList') private optionsCheckList: CheckListOptionsComponent;
  // Emite el cierre del componente
  @Output() closeComponent: EventEmitter<boolean> = new EventEmitter();
  // salida del evento de guardar la lista de chequeo
  @Output() saveForm: EventEmitter<SubForma> = new EventEmitter();
  // salida del evento de actualizar la lista de chequeo
  @Output() updateForm: EventEmitter<SubForma> = new EventEmitter();

  constructor(
    private clfs: CheckListFormsService,
    private clds: CheckListDataService,
  ) { }

  async ngOnInit() {
    this.templatesNgSelect = {
      'templateNgSelect': this.templateNgSelect,
      'ngSelectColums': this.ngSelectColums,
      'ngSelectTpl': this.ngSelectTpl
    };
    if (this.formPrincipal.alias) {
      this.allForms.push({
        key: this.formPrincipal.alias,
        value: this.formPrincipal.alias
      });
    }
    if (
      this.formPrincipal &&
      this.formPrincipal.asociaciones &&
      this.formPrincipal.asociaciones.length
    ) {
      this.formPrincipal.asociaciones.forEach(association => {
        this.allForms.push({
          key: association.aliasAsociacion,
          value: association.aliasAsociacion
        });
      });
    }

    // Consulta lista de maestras
    this.clds.getMasterTables().subscribe(async mt => {
      this.masterTables = mt;
      this.options = {
        masterTables: this.masterTables,
        forms: this.allForms
      };
      if (!this.update) {
        this.loadingForm();
        this.checkLisdtOptions = [];
      } else {
        if (
          this.form.estilo['opciones_chequeo'] &&
          this.form.estilo['opciones_chequeo'].length
        ) {
          this.checkLisdtOptions = this.form.estilo['opciones_chequeo'];
        } else {
          this.checkLisdtOptions = [];
        }
        this.typeSourceSelect = this.form.estilo['tipo'];
        if (this.typeSourceSelect === 'TablaMaestra') {
          this.idMasterSelected = this.form.estilo['maestra'];
          this.columnMasterSelect = this.form.estilo['columna_seleccionada'];
          this.master = await this.clds.getInformacionMasterTable(this.idMasterSelected);
          this.columnsMaster = await this.loadingColumnsViews(this.master.estructura, this.idMasterSelected);
          this.columnsMasterFilters = await this.loadingColumnsFilters(this.master.estructura, this.idMasterSelected);
          this.options['optionsSelectColum'] = this.columnsMaster;
          if (this.form.estilo['cargar_tabla']){
            this.formSelect = this.form.estilo['cargar_tabla']['form'];
            this.formularioSelect = this.form.estilo['cargar_tabla']['formulario'];
            this.getFormulario(this.form, false, true);
          }
          this.loadingForm(this.form);
        } else if (this.typeSourceSelect === 'TablaForma') {
          this.formSelect = this.form.estilo['cargar_tabla']['form'];
          this.formularioSelect = this.form.estilo['cargar_tabla']['formulario'];
          this.getFormulario(this.form, false);
        }

      }
      this.optionsCheckList.setListOptions(this.checkLisdtOptions);
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  trigger(callback: any, ...args: any[]) {
    return callback(...args);
  }

  /**
   * Carga los controles del formulario para agregar o actualizar una lista de cequeo
   *
   * @param {*} [data=null]
   * @memberof CheckListComponent
   */
  async loadingForm(data: any = null) {
      this.controls = this.clfs.getFormCheckList(this.templatesNgSelect, this.options, data);
  }

  /**
   * Controla el cambio del formulario para las consulta de las columnas o
   * formularios dependiendo de la accion realizada
   *
   * @param {*} data
   * @memberof CheckListComponent
   */
  async changeForm(data: any) {
    if (data.change) {
      // Se crea un nuevo control para guardar temporalmente la informacion ya ingresada en el formulario
      const tmpCheckList = {
        nombre: data.change.txtNombre,
        descripcion: data.change.txtDescripcion,
        alias: data.change.txtAlias,
        estilo: {
          sincronizado: data.change.chSincronizar,
          aliasSincronizado: data.change.txtAliasSincronizacion,
          ocultar_registros: data.change.chOcultar
        },
        campos: [
          {
            tipo_campo: {
              nombre: 'textarea'
            },
            label: data.change.txtNombreColumnaRequisitos
          },
          {
            tipo_campo: {
              nombre: 'text'
            },
            label: data.change.txtNombreColumnaOpciones
          }
        ]
      };
      // Se valida si el tipo de carga de fuente seleccionada es diferente a la anterior
      // Para reiniciar las opciones de los selects
      if (data.change['cboTipoCarga'] !== this.typeSourceSelect) {
        this.typeSourceSelect = data.change['cboTipoCarga'];
        tmpCheckList['estilo']['tipo'] = this.typeSourceSelect;
        this.formularioSelect = '';
        this.formSelect = '';
        delete this.options['formularios'];
        delete this.options['colums'];
        this.formularios = [];
        this.fields = [];
        this.idMasterSelected = -1;
        this.columnsMaster = [];
        this.columnsMasterFilters = [];
        this.master = null;
        this.loadingForm(tmpCheckList);
      // } else if (data.change['cboMasterTable']) {
      } else if (data.change['cboTipoCarga'] === 'TablaMaestra') {
        tmpCheckList['estilo']['tipo'] = this.typeSourceSelect;
        // Se valida en que campo se realizo el cambio y se ejecuta las acciones pertinentes
        // Para cargar las opciones de los otros selects
        if (Number(data.change['cboMasterTable']) !== this.idMasterSelected) {
          this.formularioSelect = '';
          this.formSelect = '';
          this.columnMasterSelect = '';
          delete this.options['formularios'];
          delete this.options['colums'];
          this.formularios = [];
          this.fields = [];
          this.idMasterSelected = Number(data.change['cboMasterTable']);
          this.columnsMaster = [];
          this.columnsMasterFilters = [];
          this.master = null;
          if (this.idMasterSelected) {
            this.master = await this.clds.getInformacionMasterTable(this.idMasterSelected);
            this.columnsMaster = await this.loadingColumnsViews(this.master.estructura, this.idMasterSelected);
            this.columnsMasterFilters = await this.loadingColumnsFilters(this.master.estructura, this.idMasterSelected);
            this.options['optionsSelectColum'] = this.columnsMaster;
          }
          tmpCheckList['estilo']['maestra'] = this.idMasterSelected;
          tmpCheckList['estilo']['columna_seleccionada'] = null;
          tmpCheckList['estilo']['cargar_tabla'] = {
            form: data.change['cboFormMultiple'],
            formularios: data.change['cboFormularioMultiple']
          };
          this.loadingForm(tmpCheckList);
        } else if (data.change['selectColumn'] !== this.columnMasterSelect) {
          this.columnMasterSelect = data.change['selectColumn'];
        }
      } else if (data.change['cboForm'] && data.change['cboForm'] !== this.formSelect) {
        tmpCheckList['estilo']['tipo'] = this.typeSourceSelect;
        this.formSelect = data.change['cboForm'];
        this.idMasterSelected = -1;
        this.columnsMaster = [];
        this.columnsMasterFilters = [];
        this.master = null;
        tmpCheckList['estilo']['cargar_tabla'] = {
          form: data.change['cboForm']
        };
        this.formularioSelect = '';
        delete this.options['colums'];
        this.fields = [];
        this.getFormulario(tmpCheckList);
      } else if (data.change['cboFormulario'] && data.change['cboFormulario'] !== this.formularioSelect) {
        tmpCheckList['estilo']['tipo'] = this.typeSourceSelect;
        this.formularioSelect = data.change['cboFormulario'];
        tmpCheckList['estilo']['cargar_tabla'] = {
          form: this.formSelect,
          formulario: this.formularioSelect
        };
        this.getColumns(tmpCheckList);
      }
      if (data.controlChanged === "cboFormMultiple"){
        this.formSelect = data.change['cboFormMultiple'];
        tmpCheckList['estilo']['tipo'] = this.typeSourceSelect;
        tmpCheckList['estilo']['cargar_tabla'] = {
          form: data.change['cboFormMultiple'],
        };
        tmpCheckList['estilo']['maestra'] = this.idMasterSelected;
        tmpCheckList['estilo']['columna_seleccionada'] = this.columnMasterSelect;
        this.getFormulario(tmpCheckList, true,true)
      }
      if (data.controlChanged === "cboFormularioMultiple"){
        this.formSelect = data.change['cboFormMultiple'];
        this.formularioSelect = data.change['cboFormularioMultiple'];
        tmpCheckList['estilo']['tipo'] = this.typeSourceSelect;
        tmpCheckList['estilo']['cargar_tabla'] = {
          form: data.change['cboFormMultiple'],
          formulario: data.change['cboFormularioMultiple']
        };
        tmpCheckList['estilo']['maestra'] = this.idMasterSelected;
        tmpCheckList['estilo']['columna_seleccionada'] = this.columnMasterSelect;
        this.getColumns(tmpCheckList,true);
      } 
      
     
    }
  }

  /**
   * Consulta el formulario dependiendo de la forma seleccionada
   *
   * @param {*} newControl
   * @param {boolean} [update=true]
   * @memberof CheckListComponent
   */
  getFormulario(newControl: any, update: boolean = true, specialSelect: boolean = false) {
    this.formularios = [];
    const association = find(this.formPrincipal.asociaciones, {aliasAsociacion: this.formSelect});
    if (this.formPrincipal.alias === this.formSelect || this.formPrincipal.alias === this.formMultiSelect) {
      this.formPrincipal.sub_formas.forEach(subForm => {
        if (subForm.tabla) {
          if (subForm.alias) {
            this.formularios.push({
              key: subForm.alias,
              value: subForm.nombre,
            });
          }
        }
      });
      this.options['formularios'] = this.formularios;
      if (update) {
        this.loadingForm(newControl);
      } else {
        this.getColumns(newControl,specialSelect);
      }
    } else if (association) {
      const formSeleted: Forma = this.acumulateForm[this.formSelect];
      if (!formSeleted) {
        this.clds.getForm(association.idForma).subscribe(form => {
          this.acumulateForm[this.formSelect] = form;
          form.sub_formas.forEach(subForm => {
            if (subForm.tabla) {
              if (subForm.alias) {
                this.formularios.push({
                  key: subForm.alias,
                  value: subForm.nombre,
                });
              }
            }
          });
          this.options['formularios'] = this.formularios;
          if (update) {
            this.loadingForm(newControl);
          } else {
            this.getColumns(newControl, specialSelect);
          }
        });
      } else {
        formSeleted.sub_formas.forEach(subForm => {
          if (subForm.tabla) {
            if (subForm.alias) {
              this.formularios.push({
                key: subForm.alias,
                value: subForm.nombre,
              });
            }
          }
        });
        this.options['formularios'] = this.formularios;
        if (update) {
          this.loadingForm(newControl);
        } else {
          this.getColumns(newControl, specialSelect);
        }
      }
    } else {
      this.options['formularios'] = this.formularios;
      if (update) {
        this.loadingForm(newControl);
      } else {
        this.getColumns(newControl, specialSelect);
      }
    }
  }

  /**
   * Consulta las columnas dependiendo de el formulario seleccionado
   *
   * @param {*} newControl
   * @memberof CheckListComponent
   */
  getColumns(newControl: any, specialSelect: boolean = false) {
    this.fields = [];
    if (this.formPrincipal.alias === this.formSelect) {
      const subForm = find(this.formPrincipal.sub_formas, {alias: this.formularioSelect});
      if (subForm) {
        if (subForm.tabla) {
          this.fields = this.loadingColumnsTablaForma(subForm.campos, subForm.nombre, specialSelect);
        }
      }
    } else {
      const formSeleted: Forma = this.acumulateForm[this.formSelect];
      if (formSeleted) {
        formSeleted.sub_formas.forEach(subForm => {
          if (subForm.tabla && subForm.alias === this.formularioSelect) {
            this.fields = this.loadingColumnsTablaForma(subForm.campos, subForm.nombre, specialSelect);
          }
        });
      }
    }
    this.options['columns'] = this.fields;
    this.loadingForm(newControl);
  }

  /**
   * Formatea las opciones de las columnas de la maestra para renderizar en el select
   *
   * @param {ColumnaMaestra[]} structure
   * @param {number} idmaster
   * @returns {Array<OptionsColumns>}
   * @memberof CheckListComponent
   */
  loadingColumnsViews(structure: ColumnaMaestra[], idmaster: number): Array<OptionsColumns> {

    const mastersC: Array<OptionsColumns> = [];
    const masterName = find(this.masterTables, {id: Number(idmaster)}).nombre;

    structure.forEach(async etr => {
      if (etr.tipo_campo['nombre'] === 'ngSelect') {
        if (etr.maestra_dependencia['estructura']) {
          const otherMaster: Array<{
            key: string,
            value: string
            masterDependencia: string,
            column: string,
          }> = this.loadingColumnsViews(etr.maestra_dependencia['estructura'], etr.maestra_dependencia['id']);
          otherMaster.forEach(el => {
            mastersC.push({
              key: el.key,
              value: etr.id + '_' + el.value,
              masterDependencia: el.masterDependencia,
              column: etr.nombre,
              type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
            });
          });
        }
      } else {
        mastersC.push({
          key: etr.nombre,
          value: String(etr.id),
          masterDependencia: masterName,
          column: etr.nombre,
          type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
        });
      }
    });

    return mastersC;
  }

  /**
   * Formatea las opciones de las columnas de el formulario para renderizar en el select
   *
   * @param {Control[]} columns
   * @param {string} nameFont
   * @returns {Array<OptionsColumns>}
   * @memberof CheckListComponent
   */
  loadingColumnsTablaForma(columns: Control[], nameFont: string, detail: boolean = false): Array<OptionsColumns> {
    const mastersC: Array<OptionsColumns> = [];

    columns.forEach(column => {
      if (column.alias) {
        // mastersC.push({
        //   key: column.label,
        //   value: column.alias,
        //   masterDependencia: nameFont,
        //   column: column.label,
        //   type: column.tipo_campo.nombre
        // });
        if (column.tipo_campo.nombre === 'ngSelect' && detail) {
          // col.columnsSelectorModal = column.propiedades['columnsSelectorModal'];
          const columDependence = this.loadColumnsDependence(
            column.propiedades['columnsSelectorModal'],
            nameFont + ' - ' + column.label,
            column.alias
          );
          if (columDependence.length) {
            columDependence.forEach(cl => {
              mastersC.push(cl);
            });
          }
        } else {
          const col: OptionsColumns = {
            key: column.label,
            value: column.alias,
            masterDependencia: nameFont,
            column: column.label,
            type: column.tipo_campo.nombre
          };
          if (col.type === 'date-time-picker') {
            col.category = column.propiedades['tipo'];
          }
          mastersC.push(col);
        }
      }
    });

    return mastersC;
  }

  /**
   * Carga las dependencias de columnas de un selector
   *
   * @param {ColumnsTableModalSelect[]} columns
   * @param {string} nameFont
   * @param {string} prefix
   * @returns {OptionsColumns[]}
   * @memberof CreationFormComponent
   */
   loadColumnsDependence(
    columns: ColumnsTableModalSelect[],
    nameFont: string,
    prefix: string
  ): OptionsColumns[] {
    const mastersC: Array<OptionsColumns> = [];
    if (columns && columns.length) {
      columns.forEach(column => {
        if (column.key) {
          const col: OptionsColumns = {
            key: column.label,
            value: prefix + '-' + column.key,
            masterDependencia: nameFont,
            column: column.label,
            type: column.type
          };
          if (col.type === 'date-time-picker') {
            col.category = column.category;
          } else if (column.type === 'ngSelect') {
            col.columnsSelectorModal = column.columnsDependence;
            const columDependence = this.loadColumnsDependence(
              column.columnsDependence,
              nameFont + ' - ' + column.label,
              prefix + '-' + column.key
            );
            if (columDependence.length) {
              columDependence.forEach(cl => {
                mastersC.push(cl);
              });
            }
          }
          mastersC.push(col);
        }
      });
    }
    return mastersC;
  }


  /**
   * Guarda o edita la lista de chequeo y emite la informacion
   *
   * @param {*} data
   * @memberof CheckListComponent
   */
  savedList(data: any) {
    const master: InformacionTablaMaestra[] = [];
    if (data['cboTipoCarga'] === 'TablaMaestra') {
      master.push({
        id: data['cboMasterTable'],
        nombre: '',
        descripcion: '',
        estructura: [],
      });
    }
    if (!this.update) {
      const subForm: SubForma = {
        id_forma: this.idForm,
        nombre: data['txtNombre'] ? data['txtNombre'] : 'Lista de chequeo',
        alias: data['txtAlias'],
        orden: this.order,
        condiciones: [],
        asociaciones: [],
        numero_registros: 0,
        estilo: {
          tipo: data['cboTipoCarga'],
          sincronizado: data.chSincronizar,
          registros_especificos: this.tmpSpecificRecord.length ? this.tmpSpecificRecord : [],
          ocultar_registros: data.chOcultar,
          opciones_chequeo: this.optionsCheckList.getListOptions(),
          condiciones_columnas: [
            {
              index: 0,
              valor: 'Lleno',
              accion: 'Requerir',
              columna: data['txtAlias'] + '_opciones',
              mensaje: 'Faltan opciones por diligenciar'
            }
          ]
        },
        tabla: true,
        campos: [],
      };
      if (data.chSincronizar) {
        subForm.estilo['aliasSincronizado'] = data.txtAliasSincronizacion;
      }
      if (data['cboTipoCarga'] === 'TablaMaestra') {
        subForm.estilo['maestra'] = data['cboMasterTable'];
        subForm.estilo['columna_seleccionada'] = data['selectColumn'];
        subForm.estilo['filtros_maestra'] = this.tmpFormulariosFilters;
        if (data['cboFormMultiple'] != undefined){
          subForm.estilo['cargar_tabla'] = {
            'form': data['cboFormMultiple'],
            'formulario': data['cboFormularioMultiple'],
            'column': data['cboColumnMultiple'],
          };
        }
      } else {
        subForm.estilo['cargar_tabla'] = {
          'form': data['cboForm'],
          'formulario': data['cboFormulario'],
          'column': data['cboColumn'],
        };
      }
      const shortid = require('shortid');
      const generateNameR = shortid.generate();
      const generateNameO = shortid.generate();
      const generateNameRegistry = shortid.generate();
      subForm.campos = [{
        alias: data['txtAlias'] + '_requisitos',
        nombre_campo: generateNameR,
        placeholder: '',
        label: data['txtNombreColumnaRequisitos'],
        requerido: true,
        orden: 1,
        tipo_campo: {
          id: 6,
          nombre: 'textarea',
          descripcion: 'Area de texto',
        },
        espacio: 12,
        validaciones: {
          condiciones: [],
          operaciones: []
        },
        propiedades: {
          rows: 5,
          mostrarTabla: true
        },
        estilos: [],
        lista_maestra: master,
        sincronizado: data.chSincronizar,
      },
      {
        alias: data['txtAlias'] + '_opciones',
        nombre_campo: generateNameO,
        placeholder: '',
        label: data['txtNombreColumnaOpciones'],
        requerido: true,
        orden: 2,
        tipo_campo: {
          id: 1,
          nombre: 'text',
          descripcion: 'Texto',
        },
        espacio: 12,
        validaciones: {
          condiciones: [],
          operaciones: []
        },
        propiedades: {
          mostrarTabla: true
        },
        estilos: [],
        lista_maestra: [],
        sincronizado: data.chSincronizar,
      }];
      this.saveForm.emit(subForm);
    } else {
      const shortid = require('shortid');
      const generateNameRegistry = shortid.generate();
      this.form.nombre = data['txtNombre'] ? data['txtNombre'] : 'Lista de chequeo';
      this.form.alias = data['txtAlias'];
      this.form.estilo['registros_especificos'] = this.tmpSpecificRecord.length ? this.tmpSpecificRecord : [];
      this.form.estilo['opciones_chequeo'] = this.optionsCheckList.getListOptions();
      this.form.estilo['condiciones_columnas'] = [
        {
          index: 0,
          valor: 'Lleno',
          accion: 'Requerir',
          columna: data['txtAlias'] + '_opciones',
          mensaje: 'Faltan opciones por diligenciar'
        }
      ];
      this.form.campos.forEach(field => {
        if (field.tipo_campo.nombre === 'text') {
          field.alias = data['txtAlias'] + '_opciones';
          field.label = data['txtNombreColumnaOpciones'];
        } else {
          if(field.alias != data['txtAlias'] + '_requisitos' && field.alias != data['txtAlias'] + '_opciones'){
            if(data['cboColumnMultiple']){
            let aliasField = data['cboColumnMultiple'][0].split('-')[0];
            field.alias = aliasField;
            field.label = data['txtNombreRelacion'];
            field.placeholder = data['txtNombreRelacionPlaceholder'];
            }
          }else{
          field.alias = data['txtAlias'] + '_requisitos';
          field.lista_maestra = master;
          field.label = data['txtNombreColumnaRequisitos'];
          }
        }
        field.sincronizado = data.chSincronizar;
      });
      this.form.estilo['tipo'] = data['cboTipoCarga'];
      if (data['cboTipoCarga'] === 'TablaMaestra') {
        this.form.estilo['maestra'] = data['cboMasterTable'];
        this.form.estilo['columna_seleccionada'] = data['selectColumn'];
        this.form.estilo['filtros_maestra'] = this.tmpFormulariosFilters;
        if (data['cboFormMultiple'] != undefined){
          this.form.estilo['cargar_tabla'] = {
            'form': data['cboFormMultiple'],
            'formulario': data['cboFormularioMultiple'],
            'column': data['cboColumnMultiple'],
            'column_name': data['txtNombreRelacion'],
            'column_name_placeholder': data['txtNombreRelacionPlaceholder']
          };
          let aliasField = data['cboColumnMultiple'][0].split('-')[0];
          let resultField = null;
          resultField = find(this.form.campos, f => f.alias === aliasField);
          if (resultField == undefined){
            if (
              this.fields &&
              this.fields.length &&
              data['cboColumnMultiple'] &&
              data['cboColumnMultiple'].length
            ) {
              // elimina el campo sobrante si existe
              let checkResultField = null;
              this.form.campos.forEach(field =>{
                if (field.alias != data['txtAlias'] + '_requisitos' && field.alias != data['txtAlias'] + '_opciones'){
                  checkResultField = this.form.campos.indexOf(field);
                  
                }
              })
              if(checkResultField != null){
                this.form.campos.splice(checkResultField,1);
              }
              // registra el nuevo campo
              let aliasField = data['cboColumnMultiple'][0].split('-')[0];
              const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
              data['cboColumnMultiple'].forEach((col: string) => {
                const selectColumn = find(this.fields, {value: col});
                if (selectColumn) {
                  let labelSelector = selectColumn.key.replace(':', '');
                  if (selectColumn.column !== selectColumn.key) {
                    labelSelector = selectColumn.column.replace(':', '') + ' - ' + selectColumn.key.replace(':', '');
                  }
                  const columSelector: ColumnsTableModalSelect = {
                    key: selectColumn.value,
                    label: labelSelector,
                    type: selectColumn.type,
                    category: selectColumn.category
                  };
                  if (
                    selectColumn &&
                    selectColumn.columnsSelectorModal &&
                    selectColumn.columnsSelectorModal.length
                  ) {
                    columSelector.columnsDependence = selectColumn.columnsSelectorModal;
                  }
                  columnsModalSelector.push(columSelector);
                }
              });
              this.form.campos.push({
                alias: aliasField,
                nombre_campo: generateNameRegistry,
                placeholder: data['txtNombreRelacionPlaceholder'],
                label: data['txtNombreRelacion'],
                requerido: false,
                orden: 3,
                tipo_campo: {id: 8, nombre: "ngSelect", descripcion: "selector"},
                espacio: 12,
                validaciones: {
                  condiciones: [],
                  operaciones: []
                },
                propiedades: {
                  "tipo": "TablaForma",
                  "unico": false,
                  "redonly": false,
                  "bloquear": false,
                  "tramites": [],
                  "condicion": null,
                  "estructura": [],
                  "sin_filtro": false,
                  "cargar_tabla": {
                    "form": data['cboFormMultiple'],
                    "column": data['cboColumnMultiple'],
                    "formulario": data['cboFormularioMultiple']
                  },
                  "mostrarTabla": false,
                  "tipoSelector": "EnLista",
                  "validar_sede": false,
                  "campo_interno": false,
                  "filtro_tramite": [],
                  "tamano_columna": null,
                  "accionesInModal": {
                    "agregarInModal": false,
                    "eliminarInModal": false,
                    "modificarInModal": false
                  },
                  "columna_general": true,
                  "modificar_campo": false,
                  "modificar_tabla": false,
                  "activar_modificar": false,
                  "asociar_documentos": false,
                  "asociar_expediente": false,
                  "columnsSelectorModal":  columnsModalSelector,
                  "columnas_seleccionadas": null,
                  "control_acceso_maestra": [],
                  "tipo_documento_radicado": []
                },
                estilos: [],
                lista_maestra: [],
                sincronizado: data.chSincronizar,
              })
            }
            
          }else{
              const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
              data['cboColumnMultiple'].forEach((col: string) => {
                const selectColumn = find(this.fields, {value: col});
                if (selectColumn) {
                  let labelSelector = selectColumn.key.replace(':', '');
                  if (selectColumn.column !== selectColumn.key) {
                    labelSelector = selectColumn.column.replace(':', '') + ' - ' + selectColumn.key.replace(':', '');
                  }
                  const columSelector: ColumnsTableModalSelect = {
                    key: selectColumn.value,
                    label: labelSelector,
                    type: selectColumn.type,
                    category: selectColumn.category
                  };
                  if (
                    selectColumn &&
                    selectColumn.columnsSelectorModal &&
                    selectColumn.columnsSelectorModal.length
                  ) {
                    columSelector.columnsDependence = selectColumn.columnsSelectorModal;
                  }
                  columnsModalSelector.push(columSelector);
                }
              });
              resultField.placeholder = data['txtNombreRelacionPlaceholder'];
              resultField.label = data['txtNombreRelacion'];
              resultField.propiedades = {
                "tipo": "TablaForma",
                "unico": false,
                "redonly": false,
                "bloquear": false,
                "tramites": [],
                "condicion": null,
                "estructura": [],
                "sin_filtro": false,
                "cargar_tabla": {
                  "form": data['cboFormMultiple'],
                  "column": data['cboColumnMultiple'],
                  "formulario": data['cboFormularioMultiple']
                },
                "mostrarTabla": false,
                "tipoSelector": "EnLista",
                "validar_sede": false,
                "campo_interno": false,
                "filtro_tramite": [],
                "tamano_columna": null,
                "accionesInModal": {
                  "agregarInModal": false,
                  "eliminarInModal": false,
                  "modificarInModal": false
                },
                "columna_general": true,
                "modificar_campo": false,
                "modificar_tabla": false,
                "activar_modificar": false,
                "asociar_documentos": false,
                "asociar_expediente": false,
                "columnsSelectorModal":  columnsModalSelector,
                "columnas_seleccionadas": null,
                "control_acceso_maestra": [],
                "tipo_documento_radicado": []
              };
              resultField.sincronizado = data.chSincronizar;
          }
          
        }else{
          let resultField = null;
          this.form.campos.forEach(field =>{
            if (field.alias != data['txtAlias'] + '_requisitos' && field.alias != data['txtAlias'] + '_opciones'){
              resultField = this.form.campos.indexOf(field);
              
            }
          })
          if(resultField != null){
            this.form.campos.splice(resultField,1);
          }

          delete this.form.estilo['cargar_tabla'];
        }
        
        
      } else {
        let resultField = null;
          this.form.campos.forEach(field =>{
            if (field.alias != data['txtAlias'] + '_requisitos' && field.alias != data['txtAlias'] + '_opciones'){
              resultField = this.form.campos.indexOf(field);
            }
          })
          if(resultField != null){
            this.form.campos.splice(resultField,1);
          }
        this.form.estilo['cargar_tabla'] = {
          'form': data['cboForm'],
          'formulario': data['cboFormulario'],
          'column': data['cboColumn'],
        };
        delete this.form.estilo['maestra'];
        delete this.form.estilo['columna_seleccionada'];
        delete this.form.estilo['filtros_maestra'];
        delete this.form.estilo['registros_especificos'];
      }
      this.form.estilo['sincronizado'] = data.chSincronizar;
      this.form.estilo['ocultar_registros'] = data.chOcultar;
      if (data.chSincronizar) {
        this.form.estilo['aliasSincronizado'] = data.txtAliasSincronizacion;
      }
      this.updateForm.emit(this.form);
    }
  }

  /**
   * Guarda los registros especificos seleccionado en el tab de parametros especificos
   *
   * @param {number[]} data
   * @memberof CheckListComponent
   */
  saveRecordSpecific(data: number[]) {
    this.tmpSpecificRecord = data;
  }

  /**
   * Guarda los filtros agregadas a la lista de chequeo
   *
   * @param {Array<FiltrosSelectores>} filters
   * @memberof CheckListComponent
   */
  savedFilters(filters: Array<FiltrosSelectores>) {
    this.tmpFormulariosFilters = filters;
  }

  private loadingColumnsFilters(structure: ColumnaMaestra[], idmaster: number): Array<OptionsColumns> {

    const mastersC: Array<OptionsColumns> = [];
    const masterName = find(this.masterTables, {id: Number(idmaster)}).nombre;

    structure.forEach(async etr => {
      if (etr.tipo_campo['nombre'] === 'ngSelect') {
        if (etr.maestra_dependencia['estructura']) {
          const otherMaster: Array<{
            key: string,
            value: string
            masterDependencia: string,
            column: string,
          }> = this.loadingColumnsFilters(etr.maestra_dependencia['estructura'], etr.maestra_dependencia['id']);
          otherMaster.forEach(el => {
            mastersC.push({
              key: el.key,
              value: etr.id + '_' + el.value,
              masterDependencia: el.masterDependencia,
              column: etr.nombre,
              type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
            });
          });
        }
      }
      mastersC.push({
        key: etr.nombre,
        value: String(etr.id),
        masterDependencia: masterName,
        column: etr.nombre,
        type: (typeof etr.tipo_campo === 'number') ? String(etr.tipo_campo) : etr.tipo_campo.nombre
      });
    });

    return mastersC;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/check-list/check-list.component.ts